import { MuniRating } from '../pledging';

export enum MoodyRating {
  A1 = 'A1',
  A2 = 'A2',
  A3 = 'A3',
  Aa1 = 'Aa1',
  Aa2 = 'Aa2',
  Aa3 = 'Aa3',
  Aaa = 'Aaa',
  B1 = 'B1',
  B2 = 'B2',
  B3 = 'B3',
  Ba1 = 'Ba1',
  Ba2 = 'Ba2',
  Ba3 = 'Ba3',
  Baa1 = 'Baa1',
  Baa2 = 'Baa2',
  Baa3 = 'Baa3',
  C = 'C',
  Ca = 'Ca',
  Caa1 = 'Caa1',
  Caa2 = 'Caa2',
  Caa3 = 'Caa3',
  NR = 'NR',
  WR = 'WR'
}

export enum BakerRating {
  AAA = 'AAA',
  AA = 'AA',
  A = 'A',
  BBB = 'BBB',
  BB = 'BB',
  B = 'B',
  CCC = 'CCC',
  CC = 'CC',
  C = 'C',
  NR = 'NR'
}

export const bakerRatingRankingMap: Record<BakerRating, number> = {
  AAA: 10,
  AA: 9,
  A: 8,
  BBB: 7,
  BB: 6,
  B: 5,
  CCC: 4,
  CC: 3,
  C: 2,
  NR: 1
};

export enum SpRatings {
  A = 'A',
  APLUS = 'A+',
  AMINUS = 'A-',
  AA = 'AA',
  AAPLUS = 'AA+',
  AAMINUS = 'AA-',
  AAA = 'AAA',
  B = 'B',
  BPLUS = 'B+',
  BMINUS = 'B-',
  BB = 'BB',
  BBPLUS = 'BB+',
  BBMINUS = 'BB-',
  BBB = 'BBB',
  BBBPLUS = 'BBB+',
  BBBMINUS = 'BBB-',
  C = 'C',
  CC = 'CC',
  CCC = 'CCC',
  CCCPLUS = 'CCC+',
  CCCMINUS = 'CCC-',
  D = 'D',
  NR = 'NR'
}

export const moodyBakerRatingMap: Record<MoodyRating, BakerRating> = {
  [MoodyRating.A1]: BakerRating.A,
  [MoodyRating.A2]: BakerRating.A,
  [MoodyRating.A3]: BakerRating.A,
  [MoodyRating.Aa1]: BakerRating.AA,
  [MoodyRating.Aa2]: BakerRating.AA,
  [MoodyRating.Aa3]: BakerRating.AA,
  [MoodyRating.Aaa]: BakerRating.AAA,
  [MoodyRating.B1]: BakerRating.B,
  [MoodyRating.B2]: BakerRating.B,
  [MoodyRating.B3]: BakerRating.B,
  [MoodyRating.Ba1]: BakerRating.BB,
  [MoodyRating.Ba2]: BakerRating.BB,
  [MoodyRating.Ba3]: BakerRating.BB,
  [MoodyRating.Baa1]: BakerRating.BBB,
  [MoodyRating.Baa2]: BakerRating.BBB,
  [MoodyRating.Baa3]: BakerRating.BBB,
  [MoodyRating.C]: BakerRating.C,
  [MoodyRating.Ca]: BakerRating.CC,
  [MoodyRating.Caa1]: BakerRating.CCC,
  [MoodyRating.Caa2]: BakerRating.CCC,
  [MoodyRating.Caa3]: BakerRating.CCC,
  [MoodyRating.NR]: BakerRating.NR,
  [MoodyRating.WR]: BakerRating.NR
};

export const spBakerRatingMap: Record<SpRatings, BakerRating> = {
  [SpRatings.A]: BakerRating.A,
  [SpRatings.APLUS]: BakerRating.A,
  [SpRatings.AMINUS]: BakerRating.A,
  [SpRatings.AA]: BakerRating.AA,
  [SpRatings.AAPLUS]: BakerRating.AA,
  [SpRatings.AAMINUS]: BakerRating.AA,
  [SpRatings.AAA]: BakerRating.AAA,
  [SpRatings.B]: BakerRating.B,
  [SpRatings.BPLUS]: BakerRating.B,
  [SpRatings.BMINUS]: BakerRating.B,
  [SpRatings.BB]: BakerRating.BB,
  [SpRatings.BBPLUS]: BakerRating.BB,
  [SpRatings.BBMINUS]: BakerRating.BB,
  [SpRatings.BBB]: BakerRating.BBB,
  [SpRatings.BBBPLUS]: BakerRating.BBB,
  [SpRatings.BBBMINUS]: BakerRating.BBB,
  [SpRatings.C]: BakerRating.C,
  [SpRatings.CC]: BakerRating.CC,
  [SpRatings.CCC]: BakerRating.CCC,
  [SpRatings.CCCPLUS]: BakerRating.CCC,
  [SpRatings.CCCMINUS]: BakerRating.CCC,
  [SpRatings.D]: BakerRating.C,
  [SpRatings.NR]: BakerRating.NR
};

export interface Rating {
  cusip: string;
  spRating?: BakerRating | null;
  moodyRating?: BakerRating | null;
  muniRating?: MuniRating | null;
}
